import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type ImporterDebug = Record<string, string | null>;

interface DebugState {
    importer: ImporterDebug;
}

const initialState: DebugState = {
    importer: {
    },
};

const debugSlice = createSlice({
    name: "debug",
    initialState,
    reducers: {
        setImporterDebug: (state, { payload }: PayloadAction<Record<string, string>>) => {
            state.importer = {
                ...state.importer,
                ...payload,
            };
        },
    },
});

export const { setImporterDebug } = debugSlice.actions;
export const { reducer: debugReducer } = debugSlice;
